import { Injectable, inject } from '@angular/core';

import { RouterSelectors } from '@next/core-lib/router-store';
import { SiteState } from '@next/core-lib/site';
import { select, Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { switchMap, take, tap, withLatestFrom } from 'rxjs/operators';

import { loadContactpersonsRequest } from '../store/contactperson.actions';
import { getAllContactpersons } from '../store/contactperson.selectors';

@Injectable({
  providedIn: 'root',
})
export class ContactpersonsGuard {
  private readonly store = inject<Store<SiteState>>(Store);

  getContactpersons() {
    return this.store.pipe(
      select(RouterSelectors.getUrl),
      withLatestFrom(this.store.select(getAllContactpersons)),
      take(1),
      tap(([url, contactpersons]) => {
        if (url === '/contactperson' || !contactpersons || contactpersons.length === 0) {
          this.store.dispatch(loadContactpersonsRequest());
        }
      }),
    );
  }

  canActivate(): Observable<boolean> {
    return this.getContactpersons().pipe(
      switchMap(() => [true]),
      take(1),
    );
  }
}
